<h3 class="mat-h3">¿Está seguro que desea quitar la autorización <br>de <em class="opacity-medium">{{alumno.apellidosNombres}}</em>?</h3>
<mat-dialog-actions>
<button mat-button mat-dialog-close>Cancelar</button>
<button mat-raised-button color="primary" (click)="submit()">Aceptar</button>
</mat-dialog-actions>